<ng-container *ngIf='sectionals; else waiting'>
    <div  >
        <table class="table" >
          <thead>
            <tr >
              <th scope="col"  style="cursor: pointer;">{{'configuration.sectionals.num' | translate}}</th> 
              <th scope="col">{{'configuration.sectionals.sectional' | translate}}</th>

              <th scope="col" style='text-align: right;'> 
                <button type="button" class="btn btn-light" (click)="refresh()" style="margin-right: 20px"><i class="bi bi-arrow-clockwise"></i></button>
                <button type="button" class="btn btn-light" (click)='addSectional()'><i class="bi bi-plus"></i> {{ 'general.add' | translate }}</button> </th>
            </tr>
          </thead> 
          <tbody>
            <tr *ngFor="let u of sectionals" >
              <td>
                <input type="number" class="form-control" [(ngModel)]="u.item.numerazione" [disabled]='!u.modify '>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="u.item.sezionale" [readonly]='u.item.id!=""'>
              </td>
              <td >
                <button *ngIf='!u.modify' type="button" class="btn btn-light" (click)="modifyItem(u)" style='margin-right: 10px'><i class="bi bi-pencil-square"></i></button>
                <button *ngIf='u.modify' type="submit" class="btn btn-light" style="margin-right: 10px;" (click)='save(u)'>{{ 'general.save' | translate }}</button>
                <button type="button" class="btn btn-light" (click)="deleteItem(u)"><i class="bi bi-trash"></i></button>
              </td>
              
            </tr>
          </tbody>
        </table>
      </div>
    
      <ng-container *ngIf='sectionals.length==0' #noRes>
        <div>
          <ngb-toast [autohide]="false" class="warning">
              <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
              {{'general.noResults' | translate}}
          </ngb-toast>
        </div>
      </ng-container>

</ng-container>
<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>